import Cache from '../lib/cache'

const HISTORY_CACHE_KEY = 'history'
const CACHE = new Cache(HISTORY_CACHE_KEY)

/**
 * Temporary way of having current user access across all components
 */
export default {
  install(Vue, { router }) {
    /**
     * Initialize the history store
     */
    CACHE.set({
      h: [],
      c: -1,
    })

    /**
     * The history store api
     */
    const $routeHistory = {
      get hasHistory() {
        const { h } = this.getHistory()
        return h.length > 1
      },
      get current() {
        const { h, c } = this.getHistory()
        if (c < 0 || c >= h.length) return false
        return h[c]
      },
      get previous() {
        const { h, c } = this.getHistory()
        if (c <= 0) return false
        return h[c - 1]
      },
      get next() {
        const { h, c } = this.getHistory()
        if (c >= h.length) return false
        return h[c + 1]
      },
      /**
       * Access to the whole history store data
       */
      getHistory() {
        return CACHE.get()
      },
    }
    Vue.prototype.$routeHistory = $routeHistory

    /**
     * Add a new path to the history store
     * @param {string} path
     */
    const push = path => {
      const { h, c } = CACHE.get()
      h.splice(c + 1, h.length)
      const currentPath = h[h.length - 1]
      if (currentPath !== path) {
        h.push(path)
        CACHE.set({ h, c: c + 1 })
      }
    }

    /**
     * Adjust the pointer of current path in history store
     * @param {number} amount - the amount to adjust the current index by
     */
    const back = amount => {
      const { h, c } = CACHE.get()
      CACHE.set({ h, c: c - amount })
    }

    /**
     * Gets the index in history where the path was recently visited
     * @param {string} path
     */
    const getRecentHistoryIndex = path => {
      const { h, c } = CACHE.get()
      const reverseHistrory = h.slice(0, c + 1).reverse()
      return reverseHistrory.indexOf(path)
    }

    /*
     * Router Observer Handling
     */
    router.afterEach((to, from) => {
      if (to.fullPath === from.fullPath) return
      let index = getRecentHistoryIndex(to.fullPath)
      if (index !== -1) {
        back(index)
        return
      }
      push(to.fullPath)
    })
  },
}
